import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

const ModalUserSelectItem = (props) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <div className="user-item">
        {data.avatar ? (
          <div className="user-avatar">
            <img src={data.avatar} alt={data.display_name} className="avatar avatar-40" />
          </div>
        ) : (
          <div className="user-avatar">
            <div className={`avatar avatar-40 icon-avatar ${data.type === 'email' ? 'light-' : ''}gray`}>
              <i className={`fas fa-${data.type === 'email' ? 'at' : 'user'}`} />
            </div>
          </div>
        )}
        <div className="user-item-body">
          <h6 className="user-item-title">
            {data.name || data.label}
          </h6>
          <span className="user-item-details">
            {data.email}
          </span>
        </div>
      </div>
    </components.Option>
  );
};

ModalUserSelectItem.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ModalUserSelectItem;
